import Script from 'next/script';
import React from 'react';


const GTM_KEY = process.env.NEXT_PUBLIC_GTM_KEY;

const initializeGTMEvents = () => {
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
};

const availableFirstPartDomains = ['mister-auto', 'citroen', 'feuvert']
const isUK = process.env.NEXT_PUBLIC_HOST?.includes('.co.uk');
const injectFirstPartGTM = availableFirstPartDomains.some(domain => process.env.NEXT_PUBLIC_HOST?.includes(domain)) || isUK

const GTMInjector = () => {
  return (
    <Script
      strategy="afterInteractive"
      onLoad={initializeGTMEvents}
      src={injectFirstPartGTM ? `${process.env.NEXT_PUBLIC_HOST}/m/gtm.js?id=${GTM_KEY}` : `https://www.googletagmanager.com/gtm.js?id=${GTM_KEY}`} //TO BE CHANGED WHEN APPROVED
    //src={`https://www.googletagmanager.com/gtm.js?id=${GTM_KEY}`}
    />
  );
};

export default function GTM() {
  if (GTM_KEY) {
    return <GTMInjector />;
  }

  return null;
}
